package com.essntl.features.proposal.ui.selectservice.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceScreen
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.service.ui.addeditservice.AddEditServiceValidation
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import com.mohamedrejeb.richeditor.model.rememberRichTextState

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AddEditServicePopup(
    state: AddEditServiceState,
    onEvent: (AddEditServiceEvent) -> Unit,
    validation: AddEditServiceValidation,
    contactState: ContactState,
    contactEvent: (ContactEvent) -> Unit,
    service: ServiceModel? = null,
    enableEdit: Boolean = true,
    openDialog: Boolean,
    onDismissRequest: () -> Unit,
) {
    val richTextState = rememberRichTextState()

    LaunchedEffect(openDialog) {
        if (openDialog) {
            onEvent(AddEditServiceEvent.ClearService)
            if (service != null) {
                onEvent(AddEditServiceEvent.GetService(service.id))
            }
        }
    }

    if (openDialog) {
        BasicAlertDialog(
            onDismissRequest = onDismissRequest,
            properties =
                DialogProperties(
                    usePlatformDefaultWidth = false,
                ),
            modifier = Modifier.fillMaxSize(0.7f),
        ) {
            Box(
                modifier =
                    Modifier
                        .fillMaxWidth()
                        .clip(RoundedCornerShape(25.dp)),
            ) {
                Column(
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center,
                    modifier =
                        Modifier
                            .fillMaxWidth()
                            .background(color = Color.White),
                ) {
                    Box(
                        modifier =
                            Modifier
                                .fillMaxWidth()
                                .background(color = MaterialTheme.esColorScheme.bgPrimary)
                                .padding(vertical = 3.spacing, horizontal = 2.5.spacing),
                    ) {
                        Text(
                            text = if (service != null) "Edit service" else "New service",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.CenterStart),
                        )

                        EsSmallOutlineIconButton(
                            onClick = {
                                onDismissRequest()
                            },
                            iconRes = EsIcons.Close,
                            modifier = Modifier.align(Alignment.CenterEnd),
                        )
                    }

                    AddEditServiceScreen(
                        state = state,
                        onEvent = onEvent,
                        validation = validation,
                        contactState = contactState,
                        contactEvent = contactEvent,
                        richTextState = richTextState,
                    )
                }
            }
        }
    }
}